export default __webpack_public_path__ + "static/media/upload_cloud_outlined.7548f852.svg";